import { t } from '../../lib/i18n'

/**
 * The channels a platform actor can pick when composing a message.
 *
 * `broadcastRequest.channel` and `notifyOwnerRequest.channel` are the same four
 * codes, and the labels for them were already being written out twice. A third
 * copy beside the notify composer is how the list eventually disagrees with
 * itself — one screen offering a channel another screen has dropped — so the
 * two composers read it from here.
 *
 * Codes are stored, labels are looked up: nothing below ever ships `'SMS'` to
 * a reader, and nothing above ever sends `'SMS'` the label to the server.
 */
export const MESSAGE_CHANNELS = ['WHATSAPP', 'SMS', 'EMAIL', 'IN_APP'] as const

export type MessageChannel = (typeof MESSAGE_CHANNELS)[number]

/**
 * Three of the four labels already exist in the P-09 block, because a ticket
 * arrives by the same routes a message leaves by. Only SMS had to be written:
 * no ticket source is an SMS, so there was no label to borrow.
 */
export function channelLabel(channel: MessageChannel): string {
  switch (channel) {
    case 'WHATSAPP':
      return t('p.support.channelWHATSAPP')
    case 'SMS':
      return t('p.settings.channelSMS')
    case 'EMAIL':
      return t('p.support.channelEMAIL')
    case 'IN_APP':
      return t('p.support.channelIN_APP')
  }
}
